import { useEffect, useState } from "react";

import { singletonHook } from "react-singleton-hook";

import { getTemplateCategories, JiraTemplateCategory } from "./";

export const useJiraTemplateCategories = () => {
    const [data, setData] = useState<JiraTemplateCategory[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<unknown>(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const data = await getTemplateCategories();
                setData(data.taxonomyTemplateCategoryCollection.items ?? []);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        void fetchData();
    }, []);

    return { data, loading, error };
};

const init = {
    data: [],
    loading: false,
    error: null
};
export const useJiraTemplateCategoriesSingleton = singletonHook(
    init,
    useJiraTemplateCategories
);
